import {
  customerIdQuery,
  businessNameQuery,
} from 'provider/queries/hasuraQueries'
import { post as getFromHasura } from 'utils/axios'

import { AUTH_APP_SESSION_URL } from '../configs/auth'

const storeCustomerInfo = async (user) => {
  const customerRes = await getFromHasura({
    payload: customerIdQuery,
    variables: {
      email: user.email,
    },
  })

  if (customerRes.errors?.length) {
    console.error(JSON.stringify(customerRes.customer?.errors[0]))
    return
  }

  if (!customerRes?.data?.customer_customer?.length) {
    console.error('not customer found')
    return
  }

  const customerId = customerRes?.data?.customer_customer[0].id
  const firstName = customerRes?.data?.customer_customer[0].first_name
  const lastName = customerRes?.data?.customer_customer[0].last_name
  const taxId = customerRes?.data?.customer_customer[0].tax_id

  await localStorage.setItem('userId', customerId)
  await localStorage.setItem('userName', `${firstName} ${lastName}`)
  await localStorage.setItem('email', user.email)

  const businessNameRes = await getFromHasura({
    payload: businessNameQuery,
    variables: {
      taxId,
    },
  })

  if (businessNameRes.errors?.length) {
    console.error(JSON.stringify(businessNameRes.customer?.errors[0]))
    return
  }

  const companyName = businessNameRes?.data?.customer_business[0].name
  await localStorage.setItem('companyName', companyName)
}

const getSession = async () => {
  const sessionRequest = new Request(AUTH_APP_SESSION_URL, {
    method: 'GET',
    credentials: 'include',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  })

  const sessionResponse = await fetch(sessionRequest)
  if (sessionResponse.status !== 200) return null

  const session = await sessionResponse.json()

  const { user } = session
  await storeCustomerInfo(user)

  return session
}

export default getSession
